export default __webpack_public_path__ + "static/media/battery-2-light.6a25ef31.svg";